import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { wmsApi } from "./wmsApi";
import WmsLogin from "./WmsLogin";
import WmsLayout from "./WmsLayout";
import WmsDashboard from "./WmsDashboard";
import WmsReceipts from "./WmsReceipts";
import WmsReceiptDetail from "./WmsReceiptDetail";
import WmsWeighing from "./WmsWeighing";
import WmsScan from "./WmsScan";
import WmsStock from "./WmsStock";
import WmsMassBalance from "./WmsMassBalance";
import WmsSuppliers from "./WmsSuppliers";
import WmsArticles from "./WmsArticles";
import WmsStation from "./WmsStation";
import WmsPrices from "./WmsPrices";

const ALLOWED = ["wms", "admin", "superadmin"];

export default function WmsApp() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("wms_token");
    if (!t) { setChecking(false); return; }
    wmsApi.get("/auth/me")
      .then((r) => {
        const role = r.data.original_role || r.data.role;
        if (ALLOWED.includes(role) || ALLOWED.includes(r.data.role)) setUser(r.data);
        else localStorage.removeItem("wms_token");
      })
      .catch(() => localStorage.removeItem("wms_token"))
      .finally(() => setChecking(false));
  }, []);

  const logout = () => {
    localStorage.removeItem("wms_token");
    setUser(null);
  };

  if (checking) {
    return (
      <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
        <p className="font-['Chivo'] font-black text-3xl text-white tracking-tighter">i<span className="text-[#FF4500]">TRACE</span></p>
      </div>
    );
  }
  if (!user) return <WmsLogin onLogin={setUser} />;

  return (
    <WmsLayout user={user} onLogout={logout}>
      <Routes>
        <Route index element={<WmsDashboard />} />
        <Route path="carichi" element={<WmsReceipts />} />
        <Route path="carichi/:id" element={<WmsReceiptDetail />} />
        <Route path="pesata/:lotId" element={<WmsWeighing />} />
        <Route path="scan" element={<WmsScan />} />
        <Route path="giacenze" element={<WmsStock />} />
        <Route path="bilancio" element={<WmsMassBalance />} />
        <Route path="fornitori" element={<WmsSuppliers />} />
        <Route path="articoli" element={<WmsArticles />} />
        <Route path="stazione" element={<WmsStation />} />
        <Route path="prezzi" element={<WmsPrices />} />
        <Route path="*" element={<Navigate to="/wms" replace />} />
      </Routes>
    </WmsLayout>
  );
}
